import { useI18n } from '@change-corgi/core-react/i18n';

import { useLocale } from '#src/app/shared/hooks/l10n';
import { useSessionConfiguration } from '#src/app/shared/hooks/sessionConfiguration';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';

export function useGetInvolvedLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const locale = useLocale();
	const { featureConfigs } = useSessionConfiguration();
	const sourceLocation = 'source_location=footer_link';

	return processLinkGroup({
		title: translate('corgi.components.footer.section.get_involved'),
		links: [
			{
				href: `/start-a-petition/intro?${sourceLocation}`,
				title: translate('corgi.components.footer.links.sap'),
			},
			{
				href: `/topic?${sourceLocation}`,
				title: translate('corgi.components.footer.links.browse_topic'),
			},
			...(locale === 'en-US'
				? [
						{
							href: `/local?${sourceLocation}`,
							title: translate('corgi.components.footer.links.browse_location'),
						},
					]
				: []),
			...(featureConfigs.footerNonprofitLink
				? [
						{
							href: '/nonprofit?source_location=footer_link',
							title: translate('corgi.components.footer.links.nonprofits'),
						},
					]
				: []),
			{
				href: `/search?${sourceLocation}`,
				title: translate('corgi.components.footer.links.search_petitions'),
			},
		],
	});
}
